import { siteConfig, siteContent } from '../content/siteContent.js'
import { getLocalizedPath } from '../lib/routing.js'
import { KineticMarquee } from './fx/KineticMarquee.jsx'
import { MagneticButton } from './fx/MagneticCursor.jsx'
import { StatusTicker } from './fx/StatusTicker.jsx'
import { TextMaskWordmark } from './fx/TextMaskWordmark.jsx'

export function HomePage({ locale, reducedMotion }) {
  const copy = siteContent[locale]

  return (
    <main className="cinema-home">
      <section className="scene scene-hero" aria-labelledby="home-title">
        <div className="scene-hero__parallax scene-hero__parallax--back" />
        <div className="scene-hero__inner">
          <p className="scene-hero__meta">
            <span>{copy.chineseBrand}</span>
            <span>Hong Kong / Reg. {siteConfig.registrationNumber}</span>
          </p>
          <h1 id="home-title" className="sr-only">
            Chicross Studio
          </h1>
          <TextMaskWordmark reducedMotion={reducedMotion} />
          <p className="scene-hero__tagline">
            {copy.tagline}
          </p>
          <div className="scene-hero__actions">
            <MagneticButton href={`mailto:${siteConfig.contactEmail}`} className="magnetic-button--primary">
              {copy.primaryCta}
            </MagneticButton>
            <a className="ghost-link" href={getLocalizedPath(locale, 'services')}>
              {copy.secondaryCta}
            </a>
          </div>
        </div>
        <StatusTicker reducedMotion={reducedMotion} />
        <KineticMarquee reducedMotion={reducedMotion} />
      </section>

      <section className="scene scene-manifesto" data-scrub>
        <div className="scene-kicker">01 / MANIFESTO</div>
        <h2 data-reveal>{copy.manifesto}</h2>
        <aside>
          <span>{copy.manifestoAside}</span>
          <span>{siteConfig.legalName}</span>
        </aside>
      </section>

      <section className="scene scene-capabilities" data-capability-rail>
        <div className="scene-capabilities__sticky">
          <div>
            <p className="scene-kicker">02 / CAPABILITIES</p>
            <h2>{copy.pages.services.description}</h2>
          </div>
          <div className="capability-track" data-capability-track>
            {copy.services.map((service) => (
              <article className="capability-panel" key={service.code} data-code={service.code}>
                <span>{service.code}</span>
                <h3>{service.title}</h3>
                <p>{service.outcome}</p>
                <ul>
                  {service.deliverables.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="scene scene-process" data-scrub>
        <p className="scene-kicker">03 / PROCESS</p>
        <h2 data-reveal>{copy.pages.process.description}</h2>
        <div className="process-line">
          {copy.processSteps.map(([title, body], index) => (
            <article key={title} data-reveal style={{ '--index': index }}>
              <span>{String(index + 1).padStart(2, '0')}</span>
              <h3>{title}</h3>
              <p>{body}</p>
            </article>
          ))}
        </div>
      </section>

      <section className="scene scene-proof">
        <p className="scene-kicker">04 / PROOF</p>
        <h2 data-reveal>{copy.pages.work.description}</h2>
        <div className="proof-records">
          {copy.proofRecords.map(([code, title, body]) => (
            <article key={code} data-reveal>
              <span>{code}</span>
              <h3>{title}</h3>
              <p>{body}</p>
              <em>Reviewed for handoff</em>
            </article>
          ))}
        </div>
      </section>

      <section className="scene scene-research">
        <p className="scene-kicker">05 / RESEARCH</p>
        <h2 data-reveal>{copy.pages.research.description}</h2>
        <div className="lab-notes">
          {copy.pages.research.sections.map((note) => (
            <article key={note.title} data-reveal>
              <span>LAB NOTE</span>
              <h3>{note.title}</h3>
              <p>{note.body}</p>
            </article>
          ))}
        </div>
      </section>

      <section className="scene scene-contact" data-scrub>
        <p className="scene-kicker">06 / CONTACT</p>
        <h2 data-reveal>{copy.contactTitle}</h2>
        <p>{copy.contactBody}</p>
        <MagneticButton href={`mailto:${siteConfig.contactEmail}`} className="magnetic-button--hero">
          {copy.primaryCta}
        </MagneticButton>
      </section>
    </main>
  )
}
